let baseCalloutTempl = require('sma.common/components/partials/callout/base.mustache');

export default class Callout {
	constructor(options) {
		this.attachTo = options.attachTo;
		this.content = options.content || '';
		this.callout_class = options.callout_class || 'callout-warning';
		this.callout_close = 'callout_close' in options ? options.callout_close : false;

		this.build();
	}

	build() {
		this.element = $(
			baseCalloutTempl({
				content: this.content,
				callout_class: this.callout_class,
				callout_close: this.callout_close
			})
		);

		this.attachTo.append(this.element);
		$('.callout a.close').click((e) => {
			$(e.currentTarget).parents('.callout').remove();
		});
	}
}